import React, { useEffect, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import IntlCurrencyInput from "react-intl-currency-input";
import "./Style.css";
import {
  getLimitsFiducia,
  getLimitsFitBank,
  setLimitsFitBank,
} from "../../../../services/pix.service";
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import { toast } from "react-toastify";
import Asterisk from "../../../../shared/components/asterisk/asterisk";
import LimitsMessage from "../../../../shared/components/limits-message/limitsMessage";

const LimitesPix = () => {
  const [limiteDiario, setLimiteDiario] = useState(0);
  const [novoLimiteDiario, setNovoLimiteDiario] = useState(0);
  const [originalLimiteDiario, setOriginalLimiteDiario] = useState(0);

  const [limiteNoturno, setLimiteNoturno] = useState(0);
  const [novoLimiteNoturno, setNovoLimiteNoturno] = useState(0);
  const [originalLimiteNoturno, setOriginalLimiteNoturno] = useState(0);

  const [limiteTransacao, setLimiteTransacao] = useState(0);
  const [novoLimiteTransacao, setNovoLimiteTransacao] = useState(0);
  const [originalLimiteTransacao, setOriginalLimiteTransacao] = useState(0);

  const [loader, setLoader] = useState(false);
  const [changeLoader, setChangeLoader] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const override = css`
    display: flex;
    margin: 20px auto;
    border-color: red;
  `;

  const getLimits = async () => {
    if (localStorage.getItem("taxNumber") === "12345678900") {
      setLimiteDiario(50000);
      setNovoLimiteDiario(50000);

      setLimiteNoturno(1000);
      setNovoLimiteNoturno(1000);

      setLimiteTransacao(5000);
      setNovoLimiteTransacao(5000);
      return;
    }
    const bank = localStorage.getItem("bank");

    try {
      setLoader(true);

      if (bank === "450") {
        const limits = await getLimitsFitBank();
        setLimiteDiario(parseFloat(limits.data.dailyMaxValue));
        setNovoLimiteDiario(parseFloat(limits.data.dailyMaxValue));
        setOriginalLimiteDiario(parseFloat(limits.data.originalDailyMaxValue));

        setLimiteNoturno(parseFloat(limits.data.overnightMaxValue));
        setNovoLimiteNoturno(parseFloat(limits.data.overnightMaxValue));
        setOriginalLimiteNoturno(
          parseFloat(limits.data.originalOvernightMaxValue)
        );

        setLimiteTransacao(parseFloat(limits.data.transactionMaxValue));
        setNovoLimiteTransacao(parseFloat(limits.data.transactionMaxValue));
        setOriginalLimiteTransacao(
          parseFloat(limits.data.originalTransactionMaxValue)
        );
      } else {
        const limits = await getLimitsFiducia();
        setLimiteDiario(parseFloat(limits.data.dailyMaxValue));
        setNovoLimiteDiario(parseFloat(limits.data.dailyMaxValue));
        setOriginalLimiteDiario(parseFloat(limits.data.originalDailyMaxValue));

        setLimiteNoturno(parseFloat(limits.data.overnightMaxValue));
        setNovoLimiteNoturno(parseFloat(limits.data.overnightMaxValue));
        setOriginalLimiteNoturno(
          parseFloat(limits.data.originalOvernightMaxValue)
        );

        setLimiteTransacao(parseFloat(limits.data.transactionMaxValue));
        setNovoLimiteTransacao(parseFloat(limits.data.transactionMaxValue));
        setOriginalLimiteTransacao(
          parseFloat(limits.data.originalTransactionMaxValue)
        );
        console.log("limits ", limits);
      }
      setLoader(false);
    } catch (err) {
      console.log("err ", err);
      setLoader(false);
      toast.error(
        "Ocorreu um erro ao obter os limites, tente novamente mais tarde"
      );
    }
  };

  const setLimits = async () => {
    if (localStorage.getItem("taxNumber") === "12345678900") {
      toast.success("Solicitação de alteração de limite realizada com sucesso");
      return;
    }
    let values = [];

    if (novoLimiteDiario !== limiteDiario) {
      values.push({
        type: 0,
        originalValue: limiteDiario,
        newValue: novoLimiteDiario,
      });
    }
    if (novoLimiteNoturno !== limiteNoturno) {
      values.push({
        type: 3,
        originalValue: limiteNoturno,
        newValue: novoLimiteNoturno,
      });
    }
    if (novoLimiteTransacao !== limiteTransacao) {
      values.push({
        type: 4,
        originalValue: limiteTransacao,
        newValue: novoLimiteTransacao,
      });
    }

    if (!values.length) {
      toast.error("Os valores são iguais");
      return;
    }

    const bank = localStorage.getItem("bank");

    setChangeLoader(true);
    if (bank == "450") {
      const response = await setLimitsFitBank(values);
      console.log("response ", response);
      toast.success("Solicitação de alteração de limite realizada com sucesso");
    }
    setChangeLoader(false);
  };

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const handleChange = (event, value) => {
    if (event.target.id === "limiteDiario") {
      setNovoLimiteDiario(value);

      if (value == limiteDiario) {
        setHasChanges(false);
      }
    }
    if (event.target.id === "limiteNoturno") {
      setNovoLimiteNoturno(value);
    }
    if (event.target.id === "limiteTransacao") {
      setNovoLimiteTransacao(value);
    }
  };

  const checkChanges = () => {
    if (
      limiteDiario !== novoLimiteDiario ||
      limiteNoturno !== novoLimiteNoturno ||
      limiteTransacao !== novoLimiteTransacao
    ) {
      setHasChanges(true);
    } else {
      setHasChanges(false);
    }
  };

  useEffect(() => {
    getLimits();
  }, []);

  useEffect(() => {
    checkChanges();
  }, [novoLimiteDiario, novoLimiteNoturno, novoLimiteTransacao]);

  return (
    <div className="limites-pix">
      <div className="limites-pix-container col-md-10">
        <div className="header">
          <div className="col-xl-12">
            <label>
              <Link to={"/pagina-principal"}>
                Pagina inicial
                <MdKeyboardArrowRight size={20} />
              </Link>
              <Link to={"/pagina-pix"}>
                Pix
                <MdKeyboardArrowRight size={20} />
              </Link>
              Meus Limites Pix
            </label>
            <p>Ajustar Limites Pix</p>
          </div>
        </div>

        <div className="body">
          {/* <div> */}
          {/* <h1>Ajustar Limites Pix</h1> */}
          {/* <h2>Você pode configurar limites Pix diferentes do padrão</h2> */}
          {/* </div> */}

          {loader ? (
            <BeatLoader
              color={"var(--secondary-color)"}
              loading={loader}
              css={override}
              size={20}
            />
          ) : (
            <>
              <div className="input-field mb-20">
                <label>
                  Limite Diário <Asterisk />
                </label>
                <div>
                  <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    onChange={handleChange}
                    defaultValue={novoLimiteDiario}
                    value={novoLimiteDiario}
                    id={"limiteDiario"}
                    max={originalLimiteDiario}
                  />
                </div>
                <LimitsMessage limite={originalLimiteDiario} />
              </div>

              <div className="input-field mb-20">
                <label>
                  Limite Noturno <Asterisk />
                </label>
                <div>
                  <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    onChange={handleChange}
                    defaultValue={novoLimiteNoturno}
                    value={novoLimiteNoturno}
                    id={"limiteNoturno"}
                    max={originalLimiteNoturno}
                  />
                </div>
                <LimitsMessage limite={originalLimiteNoturno} />
              </div>

              <div className="input-field mb-20">
                <label>
                  Limite por Transação <Asterisk />
                </label>
                <div>
                  <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    onChange={handleChange}
                    defaultValue={novoLimiteTransacao}
                    value={novoLimiteTransacao}
                    id={"limiteTransacao"}
                    max={originalLimiteTransacao}
                  />
                </div>
                <LimitsMessage limite={originalLimiteTransacao} />
              </div>

              <div className="button-area">
                <button className="reset-button" onClick={getLimits}>
                  Cancelar
                </button>
                <button
                  className="confirm-button"
                  onClick={setLimits}
                  disabled={!hasChanges}
                >
                  {changeLoader ? (
                    <BeatLoader
                      color="white"
                      loading={changeLoader}
                      css={override}
                      size={20}
                    />
                  ) : (
                    "Salvar ajustes"
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LimitesPix;
